// Deterministic replacement for the CSS-only (cqw) archway shape attempt.
// Two different pure-CSS approaches produced an inconsistent, "pointy"
// curve at variable/stretched heights across browsers — rather than keep
// guessing at CSS quirks, this measures the element's REAL rendered width
// in pixels and sets an exact matching border-radius. Since the value is
// just "half the real width," this is correct by construction in any
// browser that supports ResizeObserver (effectively all of them), with no
// dependency on percentage/container-query resolution behavior at all.
class ShapeArchway extends HTMLElement {
  constructor() {
    super();
    this.updateRadius = this.updateRadius.bind(this);
  }

  connectedCallback() {
    this.updateRadius();

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.updateRadius);
      this.resizeObserver.observe(this);
    } else {
      // Very old browsers without ResizeObserver: fall back to a plain
      // resize listener rather than leaving the shape unmeasured.
      window.addEventListener('resize', this.updateRadius);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.updateRadius);
  }

  updateRadius() {
    const width = this.getBoundingClientRect().width;
    if (width > 0) {
      this.style.setProperty('--shape-archway-radius', width / 2 + 'px');
    }
  }
}

customElements.define('shape-archway', ShapeArchway);
